var _rect, _rect2, _rect3, _path, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 24,
    viewBox: "0 0 68 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 11 7)",
    fill: "#FF644C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 17 7)",
    fill: "#FF644C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 23 7)",
    fill: "#FF644C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.984 16V12.388H29.652V16H28.248V7.6H29.652V11.176H33.984V7.6H35.388V16H33.984ZM37.8691 16V7.6H39.2731V16H37.8691ZM44.9997 16.156C43.8317 16.156 42.9317 15.804 42.2997 15.1C41.6677 14.388 41.3517 13.284 41.3517 11.788C41.3517 11.012 41.4317 10.352 41.5917 9.808C41.7597 9.256 42.0037 8.808 42.3237 8.464C42.6517 8.112 43.0557 7.856 43.5357 7.696C44.0237 7.528 44.5917 7.444 45.2397 7.444C46.0237 7.444 46.6717 7.572 47.1837 7.828C47.6957 8.084 48.0917 8.5 48.3717 9.076L47.2557 9.748C47.0397 9.332 46.7717 9.036 46.4517 8.86C46.1397 8.684 45.7357 8.596 45.2397 8.596C44.8397 8.596 44.4837 8.644 44.1717 8.74C43.8677 8.836 43.6077 9.004 43.3917 9.244C43.1837 9.484 43.0237 9.812 42.9117 10.228C42.8077 10.636 42.7557 11.156 42.7557 11.788C42.7557 12.412 42.8077 12.932 42.9117 13.348C43.0237 13.756 43.1837 14.088 43.3917 14.344C43.6077 14.592 43.8677 14.768 44.1717 14.872C44.4757 14.976 44.8237 15.028 45.2157 15.028C45.4637 15.028 45.7117 14.996 45.9597 14.932C46.2077 14.86 46.4317 14.744 46.6317 14.584C46.8397 14.424 47.0077 14.212 47.1357 13.948C47.2637 13.684 47.3357 13.352 47.3517 12.952V12.724H45.2637V11.656H48.6357V16H47.5557L47.4717 14.872C47.2397 15.28 46.9077 15.596 46.4757 15.82C46.0437 16.044 45.5517 16.156 44.9997 16.156ZM56.4488 16V12.388H52.1168V16H50.7128V7.6H52.1168V11.176H56.4488V7.6H57.8528V16H56.4488Z",
    fill: "#D0D0D0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67,
    height: 23,
    rx: 3.5,
    stroke: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighBadge);
export default __webpack_public_path__ + "static/media/highBadge.34e0c209fc6130894cf4cd575b521988.svg";
export { ForwardRef as ReactComponent };